<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>
    {{
      'invite-signup-process-congratulations.component.about_deal_header'
        | localise: 'Tell us about your deal'
    }}
  </h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <mat-form-field class="advance-step__question">
    <input
      matInput
      ngx-google-places-autocomplete
      placeholder="Property Address"
      name="streetAddress"
      #placesRef="ngx-places"
      (onAddressChange)="handleAddressChange($event)"
      appDisableAutofill
      [(ngModel)]="propertyAddress"
      (focus)="setAutoFillOff($event)" />
  </mat-form-field>
</mat-dialog-content>

<div class="actions" mat-dialog-actions>
  <button
    type="submit"
    (click)="inviteSignupProcessService.close.next()"
    class="p-button p-button--rounded p-button--application-next no-deals">
    {{
      'invite-signup-process-congratulations.component.no_pending_deals_button'
        | localise: 'No Pending Deals'
    }}
  </button>
  <button
    type="submit"
    (click)="next()"
    class="p-button p-button--rounded p-button--application-next">
    {{
      'invite-signup-process-congratulations.component.next_button'
        | localise: 'Next'
    }}
  </button>
</div>
